module.exports = __webpack_public_path__ + "static/media/landing-bg.d34723c1.jpg";